import {
  Box,
  Card,
  CardContent,
  Typography,
  CardActionArea,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { sxStyles } from "./CheckBoxCard.styles";
import { CheckBoxCardProps } from "./CheckBoxCard.types";
import IMAGES from "lib/assets/images";

const CheckBoxCard = ({
  title,
  titleBold = true,
  checked = false,
  value,
  disabled = false,
  handleChange,
}: CheckBoxCardProps) => {
  const classes = sxStyles(titleBold);

  const handleClickCard = () => {
    if (handleChange) {
      handleChange(!checked);
    }
  };

  return (
    <Card sx={classes.card} onClick={handleClickCard}>
      <CardActionArea sx={classes.actionArea}>
        <CardContent sx={classes.content}>
          <FormControlLabel
            control={
              <Checkbox
                sx={classes.checkbox}
                icon={
                  disabled ? (
                    <Box
                      sx={classes.checkIcon}
                      aria-label="disabled unchecked"
                      component={"img"}
                      src={IMAGES.general.CheckBoxOutlineBlankIconDisabled}
                    />
                  ) : (
                    <Box
                      sx={classes.checkIcon}
                      aria-label="enabled unchecked"
                      component={"img"}
                      src={IMAGES.general.CheckBoxOutlineBlankIcon}
                    />
                  )
                }
                checkedIcon={
                  disabled ? (
                    <Box
                      sx={classes.checkIcon}
                      aria-label="disabled checked"
                      component={"img"}
                      src={IMAGES.general.CheckBoxIconDisabled}
                    />
                  ) : (
                    <Box
                      sx={classes.checkIcon}
                      aria-label="enabled checked"
                      component={"img"}
                      src={IMAGES.general.CheckBoxIcon}
                    />
                  )
                }
                checked={checked}
                disabled={disabled}
                onChange={() => {
                  handleChange(!checked);
                }}
                color="primary"
              />
            }
            disabled={disabled}
            label={
              <Box sx={classes.textContainer}>
                {title && <Typography sx={classes.title}>{title}</Typography>}
              </Box>
            }
            value={value}
            sx={classes.checkboxText}
          />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CheckBoxCard;
